import { FormArray } from '@angular/forms';
import { addError, removeError } from '../utils/error-functions';

export class FormValidator {
  static validateForm(tabFormArray: FormArray): any {

    tabFormArray.controls.forEach((individualFormGroup) => {

      const formsWithSameName = tabFormArray.controls.filter((anotherFormGroup) => {

        const anotherFormId = anotherFormGroup.value.form && anotherFormGroup.value.form.id;
        const formId = individualFormGroup.value.form && individualFormGroup.value.form.id;

        const anotherMaintenanceTypeId = anotherFormGroup.value.maintenanceType && anotherFormGroup.value.maintenanceType.id;
        const maintenanceTypeId = individualFormGroup.value.maintenanceType && individualFormGroup.value.maintenanceType.id;

        const anotherSelectedMaintenanceTypeId = anotherFormGroup.value.maintenanceType && anotherFormGroup.value.maintenanceType.selectedMaintenanceType && anotherFormGroup.value.maintenanceType.selectedMaintenanceType.id;
        const selectedMaintenanceTypeId = individualFormGroup.value.maintenanceType && individualFormGroup.value.maintenanceType.selectedMaintenanceType && individualFormGroup.value.maintenanceType.selectedMaintenanceType.id;

        return anotherFormId === formId &&
          ((anotherSelectedMaintenanceTypeId || anotherMaintenanceTypeId) === (selectedMaintenanceTypeId || maintenanceTypeId));
      });

      formsWithSameName.forEach((control) => {
        const isDuplicated = formsWithSameName.length > 1;
        const formControl = control.get('form');

        if (isDuplicated) {
          addError(formControl, 'formDuplicated');
        } else {
          removeError(formControl, 'formDuplicated');
        }
      });
    });

    return null;
  }
}
